import React from "react";
import cabinetStyle from "./MentorCabinet.module.css";
import PageTips from "../PageTips";
import Style from "../Style.module.css";
import VideoComponent_IndividualGames from "./VideoComponent_IndividualGames";
import VideoComponent_GroupGames from "./VideoComponent_GroupGames";
import Banner from "./Banner";
import {useTranslation} from "react-i18next";


function MentorDocs() {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'mentorDocs' });

    return(
        <>
            {/*<Banner></Banner>*/}
            <div className={cabinetStyle.mainPageContainer}>
                <PageTips headerText={t('header')}>
                    <div className={Style.h5Heading}>{t('headerText1')}</div>
                    <ul>
                        <li className={Style.bodyBaseText}>{t('headerText2')}</li>
                        <li className={Style.bodyBaseText}>{t('headerText3')}</li>
                    </ul>

                    <div className={Style.bodyBaseText}>{t('headerText4')}</div>
                </PageTips>

                <div className={`${cabinetStyle.commonTile} ${cabinetStyle.docsGroup}`}>
                    <header className={Style.h5Heading}>{t('gameFunctions')}</header>
                    <a className={cabinetStyle.cabinetLink} href={i18n.language === "en" ? "/about_recording_en" : "/about_recording"} target="_blank">{t('videoRecord')}</a>
                </div>

                <div className={`${cabinetStyle.commonTile} ${cabinetStyle.docsGroup}`}>
                    <header className={Style.h5Heading}>{t('videoInstructions')}</header>
                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                        <VideoComponent_IndividualGames></VideoComponent_IndividualGames>
                        <VideoComponent_GroupGames></VideoComponent_GroupGames>
                    </div>

                </div>

                <div className={`${cabinetStyle.commonTile} ${cabinetStyle.docsGroup}`}>
                    <header className={Style.h5Heading}>{t('officialDocs')}</header>
                    <a className={cabinetStyle.cabinetLink} href={i18n.language === "en" ? "/price_en" : "/price"} target="_blank">{t('prices')}</a>
                    <br/>
                    <a className={cabinetStyle.cabinetLink} href={i18n.language === "en" ? "/agreement_en" : "/agreement"} target="_blank">{t('usageAgreement')}</a>
                    <br/>
                    <a className={cabinetStyle.cabinetLink} href={i18n.language === "en" ? "/about_payments_en" : "/about_payments"} target="_blank">{t('payPolicy')}</a>
                    <br/>
                    <a className={cabinetStyle.cabinetLink} href={i18n.language === "en" ? "/confidential_policy_en" : "/confidential_policy"} target="_blank">{t('confidentialityPolicy')}</a>
                    <br/>
                    <a className={cabinetStyle.cabinetLink} href={i18n.language === "en" ? "/referral_agreement_en" : "/referral_agreement"} target="_blank">{t('referralProgram')}</a>
                </div>

            </div>


        </>
    )

}

export default MentorDocs